import {createSelector} from "reselect";

const eventRules = (state) => state.eventRules;

const toList = (data) => (Array.isArray(data) ? data : data?.results || []);

export const getEventRulesListData = createSelector(
  eventRules,
  (data) => data.eventRulesListData || {}
);

export const getEventRulesList = createSelector(
  getEventRulesListData,
  (data) => data?.results || []
);

export const getEventRulesTotalCount = createSelector(
  getEventRulesListData,
  (data) => data?.count
);

export const getEventRulesPaginationUrls = createSelector(
  getEventRulesListData,
  (data) => ({
    prevUrl: data?.previous,
    nextUrl: data?.next,
  })
);

export const getContentTypesListData = createSelector(
  eventRules,
  (data) => data.contentTypesListData || {}
);

export const getContentTypesList = createSelector(getContentTypesListData, (data) =>
  toList(data).map((item) => ({
    label: `${item.app_label} > ${item.model}`,
    value: item.id,
  }))
);

export const getEventFieldTypesListData = createSelector(
  eventRules,
  (data) => data.eventFieldTypesListData || {}
);

export const getEventFieldTypesList = createSelector(getEventFieldTypesListData, (data) =>
  toList(data).map((item) => ({
    label: item?.label,
    value: item?.value,
  }))
);

export const getEventWebhooksListData = createSelector(
  eventRules,
  (data) => data.eventWebhooksListData || {}
);

export const getEventWebhooksList = createSelector(getEventWebhooksListData, (data) =>
  toList(data)
);
